import React from 'react';

import AnswerEditorContainer from '../answer/answer_editor_container';
import PageLayout from 'components/page_layout';

const SnippetAdminPage = props => {
  return (
    <PageLayout id="snippetAdmin-page" className="snippetAdmin-page">
      <AnswerEditorContainer />
    </PageLayout>
  );
};

export default SnippetAdminPage;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/knowledge_base/snippet/snippet_admin_page.jsx